import React, { useState } from 'react';
import { MainDialog } from '@components/dialog/main.dialog';
import { MainDialogTitle } from '@components/dialog/main.dialog.title';
import { Button, DialogActions } from '@material-ui/core';
import { CancelToken } from 'axios';
import { useAuth } from '@domain/auth/auth.hook';
import { useFormData } from '@domain/hooks/use.form.data';
import MetricsComboBox from '@screens/players/player.actions/metrics/metrics.combo.list';
import { useParams } from 'react-router-dom';
import { CenteredRoot } from '@styles/common';
import { ErrorDisplay } from '@components/error/error.display';
import { Loading } from '@components/loading';
import { ToggleDialogProps } from '@screens/players/player.actions/toggles/toggle.dialog.props';
import { noop } from '@domain/utils/function.utils';
import { useSnackbar } from 'notistack';
import GamesComboBox from './metrics.games.combo';

const MetricsDialog = (props: ToggleDialogProps) => {
  return (
    <MainDialog {...props}>
      <MainDialogTitle icon='analytics'>Metrics</MainDialogTitle>
      <MetricsDialogContent {...props} />
    </MainDialog>
  );
};

interface MetricFormData {
  pid: number;
  metric?: string;
  game?: string;
}

const MetricsDialogContent = ({ open }: ToggleDialogProps) => {
  const { enqueueSnackbar } = useSnackbar();
  const { authorizedServices } = useAuth();
  const { pid } = useParams();

  const [game, setGameId] = useState('');

  const [metric, setMetrics] = useState('');

  async function sendMetric(data: MetricFormData, cancelToken: CancelToken | undefined) {
    if (!pid && !game && !metric) throw new Error('Select at least one Metric');
    if (cancelToken) cancelToken.throwIfRequested();
    return authorizedServices.post('/admin/metrics/save', { pid, metric, game, cancelToken });
  }

  const formData = useFormData({ pid }, sendMetric);

  const { loading, error, submitAsync } = formData;

  function success() {
    open.disable();
    enqueueSnackbar('Metric Sent successfully', { variant: 'success' });
  }

  function submit(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
    submitAsync(e).then(success, noop);
  }

  return (
    <>
      <CenteredRoot>
        <Loading loading={loading} />
        <MetricsComboBox onChange={setMetrics} comboLabel='Metrics' />
        <GamesComboBox onChange={setGameId} comboLabel='Game' />
        <DialogActions>
          <Button onClick={submit} color='primary' disabled={loading}>
            SAVE
          </Button>
        </DialogActions>
        <ErrorDisplay error={error} />
      </CenteredRoot>
    </>
  );
};

export default MetricsDialog;
